
document.addEventListener("DOMContentLoaded", function () {
    let policies = document.querySelectorAll(".desc-policy");
    
    policies.forEach(function (policy) {
        if (policy.textContent.trim() === "Return it within 30 days for an exchange.") {
            policy.textContent = "Return it within 7 days for an exchange.";
        }
    });
});

  

const spanElement = document.querySelector('.search-header__submit-icon');

  if (spanElement) {
    spanElement.innerHTML = '<i class="zmdi zmdi-search"></i>';
  }

const searchInput = document.querySelector('.search-header__input');

if (searchInput) {
  searchInput.placeholder = 'Search Your Products';
}

document.addEventListener("DOMContentLoaded", function () {
    // Select the target div
    let targetDiv = document.getElementById("shopify-section-template--18434114388196__nov_products_grid_teEB96");

    // Create a new div element
    let newDiv = document.createElement("div");
newDiv.classList.add("main-jewel-section"); 
    newDiv.innerHTML = `
    <div class="jewels-core">
        <div class="container">
            <h2 class="tagline">MAGIZHI JEWELS AS UNIQUE AS YOU ARE</h2>
            <p class="description">
                Elegance Is Timeless, And So Is Our Jewelry <img src="https://wdtswarna.wpengine.com/wp-content/uploads/2024/11/Dimond-Ring-3.png" alt="Ring" class="icon"> Designed With Care. Each Piece <img src="https://wdtswarna.wpengine.com/wp-content/uploads/2024/11/Ring-with-box-3.png" alt="Jewelry Box" class="icon"> Reflects Your Unique Story <img src="https://wdtswarna.wpengine.com/wp-content/uploads/2024/11/Rings-Set-1.png" alt="Wedding Rings" class="icon">Making Every Moment <img src="https://wdtswarna.wpengine.com/wp-content/uploads/2024/11/Chain-img-1.png" alt="Bracelet" class="icon"> Unforgettable And Every Look.
            </p>
            <div class="features">
                <div class="feature">
                   <svg id="fi_15178196" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m350.717 302.676c2.505.234 4.941-.891 6.386-2.949 1.444-2.059 1.673-4.734.6-7.008l-25.596-54.226c6.268-1.689 11.865-5.007 16.874-10.016 9.57-9.571 13.029-21.258 10.575-35.729-1.638-9.668 2.157-18.831 10.152-24.509 11.968-8.5 17.787-19.21 17.787-32.743s-5.818-24.243-17.787-32.743c-7.995-5.678-11.79-14.841-10.151-24.511 2.449-14.476-1.011-26.162-10.577-35.728-9.571-9.571-21.259-13.031-35.728-10.575-9.668 1.638-18.831-2.157-24.51-10.152-8.501-11.969-19.211-17.787-32.743-17.787s-24.243 5.818-32.743 17.787c-5.679 7.995-14.844 11.791-24.51 10.151-14.476-2.449-26.162 1.01-35.728 10.577s-13.029 21.257-10.575 35.729c1.638 9.668-2.157 18.831-10.153 24.509-11.968 8.501-17.786 19.211-17.786 32.743s5.818 24.243 17.786 32.742c7.995 5.679 11.791 14.842 10.152 24.511-2.449 14.475 1.01 26.162 10.577 35.728 5.118 5.118 10.849 8.471 17.28 10.124l-25.627 54.294c-1.073 2.274-.845 4.949.6 7.008s3.878 3.18 6.386 2.949l29.48-2.771 18.917 22.78c1.343 1.617 3.324 2.528 5.385 2.528.405 0 .812-.035 1.219-.107 2.476-.438 4.527-2.17 5.373-4.539l20.062-56.169c4.27 1.614 8.893 2.417 13.906 2.417 5.164 0 9.914-.854 14.29-2.567l20.053 56.143c.846 2.368 2.897 4.101 5.373 4.539.407.072.814.107 1.219.107 2.06 0 4.042-.911 5.385-2.528l18.917-22.78zm-137.739 1.793-13.433-16.175c-1.478-1.779-3.737-2.714-6.041-2.497l-20.932 1.968 22.776-48.252c1.117-.12 2.246-.265 3.398-.46 9.669-1.638 18.832 2.157 24.509 10.152 2.095 2.95 4.327 5.523 6.7 7.731l-16.978 47.534zm21.692-63.371c-7.505-10.567-18.906-16.434-31.387-16.434-2.261 0-4.561.193-6.875.585-10.081 1.709-17.105-.287-23.49-6.672-6.383-6.383-8.379-13.409-6.673-23.492 2.557-15.093-3.368-29.396-15.849-38.262-8.336-5.92-11.893-12.299-11.893-21.329s3.557-15.408 11.893-21.329c12.482-8.865 18.407-23.169 15.849-38.263-1.709-10.079.286-17.104 6.672-23.49 6.383-6.384 13.407-8.378 23.491-6.672 15.091 2.56 29.397-3.368 38.262-15.848 5.921-8.336 12.3-11.893 21.329-11.893s15.408 3.557 21.33 11.894c8.864 12.479 23.165 18.401 38.263 15.848 10.077-1.709 17.103.286 23.49 6.672 6.383 6.382 8.378 13.408 6.673 23.49-2.558 15.093 3.366 29.397 15.848 38.262 8.336 5.921 11.893 12.3 11.893 21.329s-3.557 15.408-11.894 21.329c-12.481 8.865-18.406 23.169-15.848 38.263 1.709 10.079-.286 17.104-6.672 23.49-6.383 6.384-13.407 8.381-23.491 6.673-15.093-2.559-29.397 3.367-38.262 15.848-5.922 8.337-12.301 11.894-21.33 11.894s-15.408-3.557-21.329-11.893zm78.157 47.02-13.432 16.174-17.029-47.675c2.251-2.138 4.377-4.599 6.376-7.413 5.679-7.995 14.842-11.79 24.511-10.151 1.317.223 2.604.38 3.875.504l22.671 48.03-20.932-1.967c-2.305-.216-4.563.718-6.041 2.498zm28.358-152.623c0-46.972-38.214-85.186-85.186-85.186s-85.186 38.214-85.186 85.186 38.214 85.186 85.186 85.186 85.186-38.214 85.186-85.186zm-85.186 71.186c-39.252 0-71.186-31.934-71.186-71.186s31.934-71.186 71.186-71.186 71.186 31.934 71.186 71.186-31.934 71.186-71.186 71.186zm56.091-89.172c-1.322-4.069-4.78-6.929-9.024-7.462l-26.028-3.271-11.154-23.743c-1.819-3.872-5.607-6.277-9.885-6.277s-8.065 2.406-9.884 6.277l-11.155 23.743-26.027 3.271c-4.246.533-7.704 3.393-9.024 7.46-1.323 4.068-.206 8.414 2.915 11.341l19.134 17.946-4.931 25.764c-.804 4.202.846 8.374 4.306 10.887 3.46 2.515 7.938 2.795 11.687.732l22.979-12.651 22.981 12.652c1.667.917 3.478 1.372 5.28 1.372 2.249 0 4.483-.708 6.403-2.103 3.461-2.514 5.112-6.686 4.308-10.889l-4.931-25.765 19.135-17.947c3.119-2.927 4.235-7.272 2.914-11.338zm-34.438 21.71c-1.75 1.641-2.538 4.064-2.086 6.421l4.424 23.113-20.615-11.349c-2.102-1.157-4.65-1.157-6.752 0l-20.615 11.35 4.424-23.113c.451-2.356-.336-4.78-2.086-6.421l-17.165-16.099 23.35-2.935c2.381-.299 4.442-1.797 5.462-3.969l10.007-21.299 10.006 21.299c1.02 2.171 3.082 3.669 5.462 3.969l23.35 2.935-17.165 16.099zm-80.82 215.565c-6.03-20.497-21.01-31.979-38.356-45.275-18.863-14.458-40.239-30.842-59.457-64.086-4.382-8.192-12.548-13.148-21.875-13.265-5.9-.075-11.38 1.8-15.773 5.229-5.169-32.752-8.291-77.66-8.291-96.654 0-16.033-9.223-25.063-18.363-26.902-9.995-2.011-19.484 3.917-24.172 15.102-6.507 15.53-7.211 76.745-6.142 106.068.988 27.081 2.829 48.333 17.597 75.269 7.021 12.806 15.615 25.262 23.927 37.308 3.495 5.066 6.797 9.851 9.84 14.462 13.272 20.109 22.217 36.754 24.736 54.796-7.408 1.529-13.716 7.067-15.804 14.858l-9.892 36.917c-.48 1.793-.229 3.704.699 5.312s2.457 2.781 4.25 3.261l114.119 30.578c.596.16 1.205.239 1.812.239 1.218 0 2.427-.318 3.5-.938 1.608-.928 2.781-2.457 3.261-4.25l9.892-36.917c2.262-8.439-1.085-17.069-7.731-21.963 14.486-41.052 18.251-68.659 12.223-89.148zm-18.015 107.487-8.08 30.155-100.596-26.954 8.08-30.155c.949-3.538 4.595-5.642 8.134-4.697l87.765 23.517c3.538.948 5.645 4.597 4.697 8.134zm-7.297-23.325-76.734-20.561c-2.521-24.615-15.342-45.887-27.334-64.057-3.123-4.732-6.464-9.575-10.001-14.701-8.111-11.756-16.498-23.912-23.174-36.088-13.319-24.293-14.936-43.112-15.882-69.049-1.338-36.694.623-89.548 5.063-100.146 2.058-4.907 5.233-7.446 8.5-6.789 3.431.69 7.123 5.107 7.123 13.177 0 25.158 4.983 90.741 13.124 122.408l.006-.002c3.903 28.475 36.48 66.301 51.007 75.558 3.261 2.077 7.587 1.118 9.665-2.142s1.119-7.587-2.142-9.665c-7.365-4.693-21.313-19.484-31.907-36.113-11.017-17.295-15.52-32.215-11.75-38.939 2.024-3.61 5.747-5.697 9.883-5.682 4.165.052 7.806 2.269 9.738 5.93.041.078.084.155.128.231 20.628 35.728 44.191 53.79 63.125 68.303 16.662 12.771 28.701 21.999 33.442 38.115 5.066 17.219 1.289 42.782-11.881 80.211zm329.932-310.013c-4.688-11.184-14.176-17.11-24.171-15.102-9.14 1.838-18.363 10.869-18.363 26.902 0 18.992-3.121 63.896-8.29 96.649-4.391-3.431-9.868-5.307-15.774-5.224-9.326.118-17.493 5.073-21.875 13.265-19.218 33.244-40.594 49.627-59.457 64.086-17.346 13.295-32.326 24.778-38.356 45.275-6.028 20.489-2.263 48.096 12.222 89.148-6.645 4.894-9.992 13.523-7.73 21.962l9.892 36.917c.48 1.793 1.653 3.322 3.261 4.25 1.073.62 2.282.938 3.5.938.606 0 1.216-.079 1.812-.239l114.119-30.578c1.793-.48 3.322-1.653 4.25-3.261s1.18-3.519.699-5.312l-9.892-36.917c-2.088-7.79-8.398-13.327-15.804-14.857 2.519-18.041 11.464-34.687 24.735-54.796 3.042-4.61 6.343-9.393 9.837-14.457 8.312-12.048 16.908-24.506 23.93-37.313 14.769-26.938 16.61-48.188 17.597-75.269 1.07-29.323.366-90.538-6.143-106.068zm-67.675 306.384 8.08 30.156-100.596 26.954-8.08-30.156c-.948-3.537 1.159-7.186 4.696-8.134l87.766-23.517c.574-.154 1.15-.227 1.717-.227 2.932 0 5.623 1.96 6.417 4.923zm59.827-200.827c-.946 25.937-2.562 44.754-15.883 69.05-6.676 12.178-15.065 24.335-23.177 36.093-3.537 5.125-6.876 9.966-9.999 14.696-11.992 18.171-24.812 39.442-27.333 64.057l-76.735 20.561c-13.171-37.429-16.947-62.993-11.881-80.211 4.741-16.116 16.78-25.343 33.442-38.115 18.934-14.513 42.497-32.575 63.125-68.303.044-.077.087-.154.128-.231 1.933-3.661 5.573-5.877 9.738-5.93 4.193-.012 7.86 2.072 9.884 5.683 3.77 6.724-.733 21.644-11.75 38.938-10.593 16.628-24.542 31.419-31.907 36.113-3.26 2.078-4.219 6.405-2.142 9.665 2.078 3.259 6.403 4.219 9.665 2.142 14.527-9.257 47.105-47.082 51.008-75.558l.006.002c8.141-31.671 13.123-97.253 13.123-122.408 0-8.069 3.692-12.487 7.124-13.177 3.264-.656 6.443 1.881 8.5 6.788 4.442 10.599 6.402 63.453 5.064 100.146zm-109.585-156.352c-1.933-3.348-.786-7.629 2.562-9.562l17.234-9.95c3.349-1.932 7.629-.786 9.562 2.562s.786 7.629-2.562 9.562l-17.234 9.95c-1.103.636-2.306.939-3.494.939-2.419 0-4.772-1.255-6.068-3.501zm26.796 122.101c3.348 1.933 4.495 6.214 2.562 9.562-1.296 2.246-3.649 3.501-6.069 3.501-1.188 0-2.391-.302-3.493-.939l-17.234-9.95c-3.348-1.933-4.495-6.214-2.562-9.562 1.934-3.349 6.214-4.496 9.562-2.562zm-4.428-71.744h19.9c3.866 0 7 3.134 7 7s-3.134 7-7 7h-19.9c-3.866 0-7-3.134-7-7s3.134-7 7-7zm-287.969 61.794c3.35-1.932 7.63-.786 9.562 2.562 1.933 3.348.786 7.629-2.562 9.562l-17.234 9.95c-1.103.636-2.306.939-3.493.939-2.419 0-4.772-1.255-6.069-3.501-1.933-3.348-.786-7.629 2.562-9.562zm-39.707-54.794c0-3.866 3.134-7 7-7h19.901c3.866 0 7 3.134 7 7s-3.134 7-7 7h-19.901c-3.866 0-7-3.134-7-7zm19.911-74.307c1.933-3.349 6.215-4.496 9.562-2.562l17.234 9.95c3.348 1.933 4.495 6.214 2.562 9.562-1.296 2.246-3.649 3.501-6.068 3.501-1.188 0-2.391-.302-3.494-.939l-17.234-9.95c-3.348-1.933-4.495-6.214-2.562-9.562z"></path></svg>
                      <p>Reward Program</p>
                </div>
                <div class="feature">
                 <svg id="fi_2652181" enable-background="new 0 0 96 96" height="512" viewBox="0 0 96 96" width="512" xmlns="http://www.w3.org/2000/svg"><path id="Discount" d="m56.865 91.005c-2.029 0-3.842-1.483-5.603-2.923-1.076-.881-2.551-2.087-3.263-2.087-.711 0-2.186 1.206-3.262 2.087-1.929 1.577-4.117 3.37-6.526 2.818-2.486-.565-3.703-3.179-4.777-5.484-.536-1.153-1.348-2.896-1.925-3.175-.612-.299-2.512.162-3.769.464-2.447.589-5.219 1.253-7.179-.31-1.967-1.571-1.932-4.432-1.899-6.955.016-1.287.04-3.231-.374-3.751-.409-.512-2.302-.917-3.555-1.185-2.478-.53-5.284-1.131-6.384-3.411-1.084-2.245.181-4.791 1.295-7.037.579-1.164 1.453-2.925 1.3-3.6-.138-.605-1.644-1.774-2.64-2.548-2.017-1.564-4.304-3.34-4.304-5.908s2.287-4.343 4.305-5.909c.996-.773 2.502-1.942 2.64-2.548.153-.675-.721-2.436-1.299-3.601-1.115-2.246-2.379-4.791-1.294-7.038 1.1-2.279 3.906-2.88 6.383-3.41 1.253-.268 3.146-.673 3.554-1.184.416-.521.392-2.466.376-3.753-.032-2.523-.067-5.383 1.899-6.954 1.959-1.564 4.733-.898 7.179-.31 1.259.302 3.157.759 3.768.465.578-.279 1.389-2.021 1.926-3.175 1.073-2.306 2.289-4.919 4.775-5.484 2.406-.546 4.598 1.24 6.526 2.818 1.077.881 2.552 2.087 3.263 2.087s2.186-1.206 3.262-2.086c1.93-1.579 4.117-3.369 6.527-2.819 2.485.565 3.702 3.179 4.776 5.485.537 1.153 1.348 2.896 1.926 3.175.613.295 2.51-.163 3.767-.465 2.447-.588 5.22-1.254 7.18.31 1.967 1.571 1.932 4.431 1.899 6.955-.016 1.287-.04 3.232.374 3.751.409.511 2.302.917 3.555 1.185 2.478.53 5.284 1.13 6.384 3.41 1.084 2.246-.181 4.792-1.295 7.038-.579 1.165-1.453 2.925-1.3 3.6.138.606 1.644 1.775 2.64 2.548 2.017 1.566 4.304 3.341 4.304 5.909s-2.287 4.343-4.305 5.909c-.996.773-2.502 1.941-2.64 2.549-.153.675.721 2.435 1.299 3.6 1.115 2.246 2.379 4.791 1.294 7.038-1.1 2.279-3.906 2.88-6.383 3.409-1.253.269-3.146.674-3.555 1.185-.415.521-.391 2.466-.375 3.753.032 2.522.067 5.382-1.899 6.953-1.959 1.564-4.733.897-7.179.31-1.259-.302-3.157-.761-3.768-.464-.578.278-1.389 2.021-1.926 3.174-1.073 2.307-2.289 4.92-4.775 5.485-.312.071-.62.104-.923.104zm-25.975-12.855c.829 0 1.624.134 2.357.487 1.863.898 2.855 3.029 3.814 5.09.475 1.02 1.463 3.142 2.036 3.272.533.094 2.273-1.333 3.107-2.015 1.798-1.47 3.656-2.99 5.795-2.99s3.998 1.521 5.795 2.99c.834.682 2.522 2.081 3.109 2.015.571-.131 1.56-2.252 2.034-3.272.958-2.061 1.95-4.19 3.814-5.09 1.896-.915 4.204-.358 6.439.179 1.075.258 3.316.797 3.748.453.439-.35.41-2.665.396-3.777-.029-2.292-.059-4.661 1.249-6.299 1.3-1.628 3.609-2.122 5.843-2.6 1.094-.234 3.369-.721 3.618-1.236.232-.483-.786-2.535-1.275-3.521-1.025-2.065-2.086-4.201-1.616-6.265.455-2.002 2.302-3.436 4.087-4.822.966-.748 2.76-2.14 2.76-2.749s-1.794-2.001-2.758-2.75c-1.786-1.386-3.633-2.819-4.088-4.822-.469-2.064.592-4.2 1.617-6.265.489-.986 1.508-3.037 1.275-3.521-.249-.516-2.524-1.002-3.617-1.236-2.234-.478-4.544-.972-5.844-2.599-1.307-1.637-1.277-4.007-1.248-6.298.014-1.112.043-3.428-.396-3.778-.43-.344-2.672.195-3.749.453-2.234.537-4.542 1.093-6.439.178-1.863-.899-2.855-3.029-3.814-5.089-.475-1.02-1.462-3.142-2.036-3.272-.55-.095-2.274 1.333-3.108 2.014-1.797 1.471-3.655 2.991-5.794 2.991s-3.997-1.521-5.795-2.991c-.834-.682-2.574-2.103-3.109-2.015-.572.13-1.561 2.252-2.035 3.272-.959 2.06-1.95 4.19-3.813 5.089-1.896.914-4.204.36-6.44-.178-1.075-.259-3.318-.797-3.748-.454-.439.351-.41 2.666-.396 3.778.029 2.292.059 4.662-1.249 6.298-1.3 1.628-3.609 2.122-5.843 2.6-1.094.234-3.369.721-3.618 1.236-.232.483.786 2.535 1.275 3.521 1.025 2.065 2.086 4.201 1.616 6.265-.455 2.002-2.302 3.436-4.087 4.822-.965.75-2.759 2.142-2.759 2.751s1.794 2.002 2.758 2.75c1.786 1.386 3.633 2.818 4.088 4.821.469 2.064-.592 4.199-1.617 6.265-.489.986-1.508 3.037-1.275 3.521.249.517 2.524 1.003 3.618 1.237 2.233.478 4.543.972 5.843 2.6 1.307 1.637 1.277 4.006 1.248 6.298-.014 1.112-.043 3.428.396 3.778.43.339 2.672-.195 3.749-.454 1.369-.33 2.768-.666 4.082-.666zm4.524-14.736 28-28c.781-.781.781-2.047 0-2.828s-2.047-.781-2.828 0l-28 28c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.023-.195 1.414-.586zm2.586-18.414c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7zm0-10c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm20 30c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7zm0-10c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"></path></svg>
                    <p>Special Discounts</p>
                </div>
                <div class="feature">
               <svg id="fi_2789046" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m510.257 194.626-86.87-104.05c-1.425-1.707-3.533-2.693-5.757-2.693h-59.237c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h43.916l-65.495 84.324-65.495-84.324h52.039c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-174.694l-16.791-8.396c-2.786-1.393-4.957-3.753-6.114-6.645l-12.299-30.749c-1.139-2.848-3.896-4.715-6.963-4.715-3.066 0-5.825 1.867-6.963 4.714l-12.3 30.749c-1.157 2.892-3.329 5.252-6.114 6.645l-18.384 9.192c-2.541 1.27-4.146 3.867-4.146 6.708s1.605 5.438 4.146 6.708l11.467 5.733-72.46 86.799c-2.419 2.898-2.308 7.142.261 9.909l82.584 88.963c1.478 1.592 3.485 2.397 5.499 2.397 1.826 0 3.657-.663 5.101-2.003 3.036-2.818 3.212-7.563.394-10.599l-70.885-76.36h144.92l69.839 231.342-45.919-49.469 4.197-2.098c2.541-1.27 4.146-3.867 4.146-6.708s-1.605-5.438-4.146-6.708l-14.248-7.125c-1.789-.894-3.183-2.409-3.926-4.267l-9.532-23.831c-1.139-2.847-3.896-4.714-6.963-4.714s-5.825 1.867-6.963 4.714l-2.912 7.28-33.662-36.262c-2.817-3.036-7.563-3.212-10.599-.394s-3.212 7.563-.394 10.599l38.492 41.465-.457 1.142c-.743 1.857-2.137 3.373-3.926 4.267l-14.248 7.124c-2.541 1.271-4.146 3.867-4.146 6.708s1.605 5.438 4.146 6.708l14.248 7.123c1.789.895 3.183 2.41 3.926 4.267l9.532 23.831c1.139 2.847 3.896 4.714 6.963 4.714s5.825-1.867 6.963-4.714l9.532-23.831c.208-.519.471-1.007.774-1.466l70.168 75.593c1.419 1.529 3.411 2.397 5.497 2.397s4.077-.869 5.497-2.397l131.014-141.131 2.999 7.497c1.14 2.847 3.897 4.714 6.964 4.714s5.824-1.867 6.964-4.714l9.532-23.832c.742-1.856 2.137-3.372 3.925-4.266l14.248-7.124c2.541-1.271 4.146-3.868 4.146-6.708s-1.605-5.438-4.146-6.708l-4.401-2.201 33.634-36.23c2.818-3.036 2.643-7.781-.394-10.599-3.036-2.819-7.781-2.642-10.599.394l-35.764 38.525c-.251-.405-.47-.832-.65-1.28l-9.532-23.831c-1.14-2.847-3.897-4.714-6.964-4.714s-5.824 1.867-6.964 4.714l-9.532 23.832c-.742 1.856-2.137 3.372-3.926 4.266l-14.248 7.124c-2.54 1.27-4.146 3.867-4.146 6.708s1.605 5.438 4.146 6.708l14.247 7.123c1.789.895 3.184 2.41 3.926 4.267l.37.925-113.802 122.596 69.84-231.345h144.92l-7.952 8.565c-2.817 3.036-2.642 7.781.395 10.599 1.444 1.341 3.274 2.003 5.101 2.003 2.013 0 4.021-.806 5.499-2.397l19.651-21.168c2.568-2.767 2.68-7.012.26-9.909zm-121.496 101.619c5.078-2.539 9.036-6.841 11.145-12.112l2.568-6.422 2.568 6.421c2.108 5.272 6.066 9.574 11.145 12.113l.832.416-.831.415h-.001c-5.078 2.539-9.036 6.841-11.145 12.112l-2.568 6.422-2.568-6.421c-2.108-5.272-6.066-9.574-11.146-12.113l-.831-.415zm99.708-104.312h-136.334l65.706-84.596zm-401.944-75.461c.262.471.506.953.708 1.459l12.3 30.749c1.139 2.847 3.896 4.714 6.963 4.714s5.825-1.867 6.963-4.715l4.354-10.884 42.054 54.138h-136.337zm234.967 75.461h-130.981l65.488-84.321zm-172.811-89.051h91.998l-65.489 84.324-50.92-65.551 1.49-3.724c1.157-2.892 3.328-5.251 6.114-6.645zm-60.854-9.98c6.075-3.037 10.81-8.183 13.333-14.49l5.336-13.34 5.336 13.34c2.523 6.307 7.258 11.453 13.333 14.49l4.967 2.484-4.967 2.484c-6.075 3.037-10.81 8.183-13.333 14.49l-5.336 13.34-5.336-13.34c-2.522-6.306-7.258-11.452-13.333-14.489l-4.967-2.484zm77.807 299.625-2.569 6.422-2.569-6.422c-2.109-5.271-6.066-9.573-11.145-12.112l-.831-.415.831-.416c5.078-2.539 9.036-6.84 11.145-12.112l2.569-6.422 2.569 6.422c2.109 5.272 6.067 9.573 11.145 12.112l.831.416-.831.415c-5.078 2.539-9.036 6.84-11.145 12.112zm90.366 48.648-70.714-234.242h141.429z"></path></g></svg>
                    <p>Unique Designs</p>
                </div>
                <div class="feature">
                   <svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_7299817"><g id="_x32_3_Fast_delivery"><path d="m492.365 202.52-40.37-72.8c-4.4-7.93-12.76-12.85-21.82-12.85h-94.88v-19.45c0-8.81-7.16-15.97-15.97-15.97h-259.5c-3.86 0-7 3.13-7 7 0 3.86 3.14 7 7 7h259.5c1.09 0 1.97.88 1.97 1.97v214h-261.47c-3.86 0-7 3.14-7 7v43.6c0 8.8 7.17 15.97 15.98 15.97h13.53c3.48 29.55 28.69 52.56 59.16 52.56 30.48 0 55.69-23.01 59.16-52.56h121.05c3.47 29.55 28.68 52.56 59.16 52.56 30.47 0 55.68-23.01 59.16-52.56h54.13c8.81 0 15.97-7.17 15.97-15.97v-90.84c0-23.96-6.14-47.71-17.76-68.66zm-425.54 159.5v-36.6h36.35c-11.3 9.52-19.03 23.15-20.84 38.57h-13.53c-1.09 0-1.98-.89-1.98-1.97zm74.67 54.53c-25.12 0-45.57-20.44-45.57-45.56 0-25.13 20.45-45.57 45.57-45.57 25.13 0 45.57 20.44 45.57 45.57 0 25.12-20.44 45.56-45.57 45.56zm179.8-52.56h-120.64c-1.81-15.42-9.53-29.05-20.84-38.57h141.48zm59.57 52.56c-25.13 0-45.57-20.44-45.57-45.56 0-25.13 20.44-45.57 45.57-45.57 25.12 0 45.57 20.44 45.57 45.57 0 25.12-20.45 45.56-45.57 45.56zm115.26-85.1c-7.54-2.84-12.92-10.13-12.92-18.65v-21.38c0-1.09.89-1.97 1.97-1.97h10.95zm0-56h-10.95c-8.8 0-15.97 7.16-15.97 15.97v21.38c0 16.31 11.57 29.96 26.92 33.19v16.03c0 1.08-.88 1.97-1.97 1.97h-54.13c-3.48-29.56-28.69-52.57-59.16-52.57-18.27 0-34.64 8.26-45.57 21.25v-201.8h94.88c3.98 0 7.65 2.16 9.57 5.64l40.37 72.8c10.47 18.88 16.01 40.28 16.01 61.87zm-115.261 118.211c-12.502 0-22.673-10.171-22.673-22.673s10.171-22.673 22.673-22.673 22.673 10.171 22.673 22.673-10.171 22.673-22.673 22.673zm0-31.345c-4.782 0-8.673 3.891-8.673 8.673s3.891 8.673 8.673 8.673 8.673-3.891 8.673-8.673-3.891-8.673-8.673-8.673zm-239.368 31.345c-12.502 0-22.673-10.171-22.673-22.673s10.171-22.673 22.673-22.673 22.673 10.171 22.673 22.673-10.171 22.673-22.673 22.673zm0-31.345c-4.782 0-8.673 3.891-8.673 8.673s3.891 8.673 8.673 8.673 8.673-3.891 8.673-8.673-3.891-8.673-8.673-8.673zm323.654-111.38c-1.187 0-2.383-.132-3.57-.403l-105.437-24.103c-7.31-1.671-12.414-8.074-12.414-15.571v-55.583c0-8.808 7.166-15.974 15.974-15.974h62.547c5.802 0 11.155 3.152 13.97 8.227l36.524 65.867c2.845 5.131 5.332 10.533 7.392 16.056 2.041 5.471.912 11.607-2.946 16.014-3.084 3.521-7.486 5.47-12.04 5.47zm-105.447-97.634c-1.088 0-1.974.886-1.974 1.974v55.583c0 .926.631 1.717 1.533 1.923l105.438 24.102c1.012.23 1.659-.304 1.956-.642.343-.391.684-1.037.362-1.897-1.817-4.873-4.011-9.637-6.519-14.16l-36.524-65.866c-.348-.627-1.009-1.017-1.726-1.017zm-152.838-37.912c-48.55 0-88.04 39.5-88.04 88.04 0 48.55 39.49 88.04 88.04 88.04 48.54 0 88.04-39.49 88.04-88.04 0-48.54-39.5-88.04-88.04-88.04zm0 162.08c-40.83 0-74.04-33.21-74.04-74.04 0-40.82 33.21-74.04 74.04-74.04 40.82 0 74.04 33.22 74.04 74.04 0 40.83-33.22 74.04-74.04 74.04zm39.32-51.33c-1.48 2.57-4.17 4-6.93 4-1.36 0-2.73-.34-3.99-1.07l-32.4-18.71c-2.39-1.38-4-3.97-4-6.93v-41.66c0-4.41 3.58-8 8-8s8 3.59 8 8v37.05l28.4 16.39c3.82 2.21 5.13 7.1 2.92 10.93zm-163.136-96.745h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7zm0 54.027h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7zm0 54.026h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7zm0 54.027h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7z"></path></g></svg>
                    <p>Fast Shipping</p>
                </div>
                <div class="feature">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="512" height="512" id="fi_2854306"><g id="_11-best_price" data-name="11-best price"><path d="M42,42a4,4,0,0,0-4-4H25.13L26,31.12A.49.49,0,0,0,26,31c0-5.54-3.92-7-6-7a1,1,0,0,0-1,.73l-4,13.89A7.67,7.67,0,0,1,12,41.79V41a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1V63a1,1,0,0,0,1,1H11a1,1,0,0,0,1-1v-.67L17.73,64A.8.8,0,0,0,18,64H35a4,4,0,0,0,3-6.58,4,4,0,0,0,1-6,4,4,0,0,0,1-6A4,4,0,0,0,42,42ZM10,62H2V42h8Zm25,0H18.14L12,60.25V43.88c3-.69,4.81-4.26,4.89-4.43a1.34,1.34,0,0,0,.07-.18l3.77-13.18c1.17.26,3.25,1.23,3.27,4.85l-1,7.94a1,1,0,0,0,.24.78A1,1,0,0,0,24,40H38a2,2,0,0,1,0,4H33a1,1,0,0,0,0,2h4a2,2,0,0,1,0,4H32a1,1,0,0,0,0,2h4a2,2,0,0,1,0,4H31a1,1,0,0,0,0,2h4a2,2,0,0,1,0,4Z"></path><path d="M13,15h1v1a1,1,0,0,0,2,0V15h1a1,1,0,0,0,0-2H16V12a1,1,0,0,0-2,0v1H13a1,1,0,0,0,0,2Z"></path><path d="M54,50H53V49a1,1,0,0,0-2,0v1H50a1,1,0,0,0,0,2h1v1a1,1,0,0,0,2,0V52h1a1,1,0,0,0,0-2Z"></path><path d="M42,0A22,22,0,0,0,20,22a1,1,0,0,0,2,0A20,20,0,1,1,45.81,41.64a1,1,0,0,0,.19,2l.19,0A22,22,0,0,0,42,0Z"></path><path d="M51,26a8,8,0,0,0-8-8H41a2,2,0,0,1,0-4h7a3,3,0,0,0,0-6H45V5a1,1,0,0,0-1-1H40a1,1,0,0,0-1,1V8.26A8,8,0,0,0,41,24h2a2,2,0,0,1,0,4H36a3,3,0,0,0,0,6h3v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V33.74A8,8,0,0,0,51,26Zm-7.14,5.93a1,1,0,0,0-.86,1V36H41V33a1,1,0,0,0-1-1H36a1,1,0,0,1,0-2h7a4,4,0,0,0,0-8H41a6,6,0,0,1-.86-11.93,1,1,0,0,0,.86-1V6h2V9a1,1,0,0,0,1,1h4a1,1,0,0,1,0,2H41a4,4,0,0,0,0,8h2a6,6,0,0,1,.86,11.93Z"></path></g></svg>
                    <p>Great Prices</p>
                </div>
            </div>
        </div>
 </div>
 
 
    `;

    // Insert the newDiv after the targetDiv valentine-core
    if (targetDiv) {
        targetDiv.insertAdjacentElement("afterend", newDiv);
    }
});

document.addEventListener("DOMContentLoaded", function () {
    // Select the target div
    let targetDiv = document.querySelector(".Banner-main-section");

    if (targetDiv) {
        // Create a new div element
        let newDiv = document.createElement("div");
//         newDiv.innerHTML = `<div class="container-fluaid"><div class="litle-banner">
//     <div class="columnsc">
//         <a href="https://magizhi.com/collections/magizhi-minima" target="_blank"> 
//             <img src="https://cdn.shopify.com/s/files/1/0687/4854/2180/files/MAGIZHI_MAINIMA-MINIMALIST_JEWELLERY.png?v=1750501610" alt="Image 1">
//         </a>
//     </div>
//     <div class="columnsc">
//         <a href="https://magizhi.com/collections/best-sellers" target="_blank">
//             <img src="https://cdn.shopify.com/s/files/1/0687/4854/2180/files/Best_Sellers.png?v=1750502500?v=1750501825?v=1750502343" alt="Image 2">
//         </a>
//     </div>
//    <div class="columnsc">
//         <a href="https://magizhi.com/collections/combo-offer" target="_blank">
//             <img src="https://cdn.shopify.com/s/files/1/0687/4854/2180/files/White_Minimalist_Jewelry_Instagram_Story.png?v=1750510482?v=1750502500?v=1750501825?v=1750502343" alt="Image 2">
//         </a>
//     </div>
// </div></div>`;

        // Insert the new div after the valentine-core section
        targetDiv.insertAdjacentElement("afterend", newDiv);
    }
});


document.addEventListener("DOMContentLoaded", function () {
    // "Minimal Elegance" videos - light 480p versions, load only when scrolled into view
    var targetDiv = document.querySelector(".shopcategory");
    if (!targetDiv) return;

    var base = "https://cdn.shopify.com/videos/c/vp/";
    var vids = [
        "5c574d9dfa8a4721a3114027ce0a7d5f/5c574d9dfa8a4721a3114027ce0a7d5f.SD-480p-1.2Mbps-79437512.mp4",
        "45a9cc7bee28462bae521ff132c2d0ba/45a9cc7bee28462bae521ff132c2d0ba.SD-480p-0.9Mbps-79741520.mp4",
        "52d99a19fb9f4251bbc16c53423c25c4/52d99a19fb9f4251bbc16c53423c25c4.SD-480p-1.2Mbps-50280867.mp4",
        "dca70a138d834eff907d0c02ee090e1a/dca70a138d834eff907d0c02ee090e1a.SD-480p-0.9Mbps-79741296.mp4"
    ];

    var html = '<h1 class="section-title">Minimal Elegance with Magizhi</h1><div class="grid-container">';
    for (var i = 0; i < vids.length; i++) {
        html += '<div class="grid-item"><video muted loop playsinline preload="none" data-src="' + base + vids[i] + '"></video></div>';
    }
    html += '</div>';

    var newDiv = document.createElement("div");
    newDiv.innerHTML = html;
    targetDiv.insertAdjacentElement("afterend", newDiv);

    var videos = newDiv.querySelectorAll("video");
    function start(v) {
        if (!v.getAttribute("src")) v.setAttribute("src", v.getAttribute("data-src"));
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
    }
    if (!("IntersectionObserver" in window)) {
        for (var j = 0; j < videos.length; j++) start(videos[j]);
        return;
    }
    var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
            if (e.isIntersecting) start(e.target);
            else if (e.target.getAttribute("src")) e.target.pause();
        });
    }, { rootMargin: "200px" });
    for (var k = 0; k < videos.length; k++) io.observe(videos[k]);
});


document.addEventListener("DOMContentLoaded", function () {
    // Select the target div
    let targetDiv = document.querySelector(".main-jewel-section");

    if (targetDiv) {
        // Create a new div element
        let newDiv = document.createElement("div");
        newDiv.innerHTML = `
<a href="https://wa.me/8531003003" class="whatsapp-button" target="_blank">
   <svg height="682pt" viewBox="-23 -21 682 682.66669" width="682pt" xmlns="http://www.w3.org/2000/svg" id="fi_1384023"><path d="m544.386719 93.007812c-59.875-59.945312-139.503907-92.9726558-224.335938-93.007812-174.804687 0-317.070312 142.261719-317.140625 317.113281-.023437 55.894531 14.578125 110.457031 42.332032 158.550781l-44.992188 164.335938 168.121094-44.101562c46.324218 25.269531 98.476562 38.585937 151.550781 38.601562h.132813c174.785156 0 317.066406-142.273438 317.132812-317.132812.035156-84.742188-32.921875-164.417969-92.800781-224.359376zm-224.335938 487.933594h-.109375c-47.296875-.019531-93.683594-12.730468-134.160156-36.742187l-9.621094-5.714844-99.765625 26.171875 26.628907-97.269531-6.269532-9.972657c-26.386718-41.96875-40.320312-90.476562-40.296875-140.28125.054688-145.332031 118.304688-263.570312 263.699219-263.570312 70.40625.023438 136.589844 27.476562 186.355469 77.300781s77.15625 116.050781 77.132812 186.484375c-.0625 145.34375-118.304687 263.59375-263.59375 263.59375zm144.585938-197.417968c-7.921875-3.96875-46.882813-23.132813-54.148438-25.78125-7.257812-2.644532-12.546875-3.960938-17.824219 3.96875-5.285156 7.929687-20.46875 25.78125-25.09375 31.066406-4.625 5.289062-9.242187 5.953125-17.167968 1.984375-7.925782-3.964844-33.457032-12.335938-63.726563-39.332031-23.554687-21.011719-39.457031-46.960938-44.082031-54.890626-4.617188-7.9375-.039062-11.8125 3.476562-16.171874 8.578126-10.652344 17.167969-21.820313 19.808594-27.105469 2.644532-5.289063 1.320313-9.917969-.664062-13.882813-1.976563-3.964844-17.824219-42.96875-24.425782-58.839844-6.4375-15.445312-12.964843-13.359374-17.832031-13.601562-4.617187-.230469-9.902343-.277344-15.1875-.277344-5.28125 0-13.867187 1.980469-21.132812 9.917969-7.261719 7.933594-27.730469 27.101563-27.730469 66.105469s28.394531 76.683594 32.355469 81.972656c3.960937 5.289062 55.878906 85.328125 135.367187 119.648438 18.90625 8.171874 33.664063 13.042968 45.175782 16.695312 18.984374 6.03125 36.253906 5.179688 49.910156 3.140625 15.226562-2.277344 46.878906-19.171875 53.488281-37.679687 6.601563-18.511719 6.601563-34.375 4.617187-37.683594-1.976562-3.304688-7.261718-5.285156-15.183593-9.253906zm0 0" fill-rule="evenodd"></path></svg>
    Chat with us
</a>

<h1 class="section-title pt-50">Gave a Gift Your Loved Once!</h1>
    <div class="container">
    <div class="fg-container">
        <div class="card">
        <div class="banner-overlay"></div>
            <img src="https://demo-cadiant.myshopify.com/cdn/shop/files/h5_b1.webp?v=1705747626&width=533" alt="Gifts for Her">
            <div class="card-content">
                <h2>Gifts for Her</h2>
                <p>From timeless classics to modern must-haves.</p>
            </div>
        </div>
        <div class="card">
  <div class="banner-overlay"></div>
            <img src="https://demo-cadiant.myshopify.com/cdn/shop/files/h5_b2.webp?v=1705747626&width=533" alt="Stocking Stuffers">
            <div class="card-content">
                <h2>Stocking Stuffers</h2>
                <p>Curated Stocking Stuffers for your whole list.</p>
            </div>
        </div>
        <div class="card">
  <div class="banner-overlay"></div>
            <img src="https://demo-cadiant.myshopify.com/cdn/shop/files/h5_b3.webp?v=1705747626&width=533" alt="Gifts for Him">
            <div class="card-content">
                <h2>Gifts for Him</h2>
                <p>No matter his style, find a timeless gift for him.</p>
            </div>
        </div>
    </div>
</div>`;
      

        // Insert the new div after the valentine-core section
        targetDiv.insertAdjacentElement("afterend", newDiv);
    }
});
    // Select the target div
    let targetDiv = document.querySelector(".header-center.header-search__parent.d-none.d-md-block.position-relative");

    // Check if the div exists
    if (targetDiv) {
        // Replace 'pt-35' with 'pt-20'
        targetDiv.classList.replace("pt-35", "pt-20");
    }


window.theme = window.theme || {};
theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');
        constructor = constructor || this.constructors[type];
        if (_.isUndefined(constructor)) {
            return;
        }
        var instance = _.assignIn(new constructor(container), {
            id: id,
            type: type,
            container: container
        });
        this.instances.push(instance);
    },
    _onSectionLoad: function(evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },
    _onSectionUnload: function(evt) {
        this.instances = _.filter(this.instances, function(instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;
            if (isEventInstance) {
                if (_.isFunction(instance.onUnload)) {
                    instance.onUnload(evt);
                }
            }
            return !isEventInstance;
        });
    },
    _onSelect: function(evt) {
        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
            instance.onSelect(evt);
        }
    },
    _onDeselect: function(evt) {
        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
            instance.onDeselect(evt);
        }
    },
    _onBlockSelect: function(evt) {
        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
            instance.onBlockSelect(evt);
        }
    },
    _onBlockDeselect: function(evt) {
        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
            instance.onBlockDeselect(evt);
        }
    },
    register: function(type, constructor) {
        this.constructors[type] = constructor;
        $('[data-section-type=' + type + ']').each(function(index, container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});
window.slate = window.slate || {};
slate.rte = {
    wrapTable: function(options) {
        options.$tables.wrap('<div class="' + options.tableWrapperClass + '"></div>');
    },
    wrapIframe: function(options) {
        options.$iframes.each(function() {
            $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');
            this.src = this.src;
        });
    }
};
window.slate = window.slate || {};
slate.a11y = {
    pageLinkFocus: function($element) {
        var focusClass = 'js-focus-hidden';
        $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

        function callback() {
            $element.first().removeClass(focusClass).removeAttr('tabindex');
        }
    },
    focusHash: function() {
        var hash = window.location.hash;
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },
    bindInPageLinks: function() {
        $('a[href*=#]').on('click', function(evt) {
            this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this));
    },
    trapFocus: function(options) {
        var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';
        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }
        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();
        $(document).off('focusin');
        $(document).on(eventName, function(evt) {
            if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                options.$container.focus();
            }
        });
    },
    removeTrapFocus: function(options) {
        var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';
        if (options.$container && options.$container.length) {
            options.$container.removeAttr('tabindex');
        }
        $(document).off(eventName);
    }
};
theme.Images = (function() {
    function preload(images, size) {
        if (typeof images === 'string') {
            images = [images];
        }
        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    function loadImage(path) {
        new Image().src = path;
    }

    function switchImage(image, element, callback) {
        var size = this.imageSize(element.src);
        var imageUrl = this.getSizedImageUrl(image.src, size);
        if (callback) {
            callback(imageUrl, image, element);
        } else {
            element.src = imageUrl;
        }
    }

    function imageSize(src) {
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
        if (match !== null) {
            if (match[2] !== undefined) {
                return match[1] + match[2];
            } else {
                return match[1];
            }
        } else {
            return null;
        }
    }

    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }
        if (size === 'master') {
            return this.removeProtocol(src);
        }
        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (match !== null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        }
        return null;
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }
    return {
        preload: preload,
        loadImage: loadImage,
        switchImage: switchImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();
theme.Currency = (function() {
    var moneyFormat = '${{amount}}';

    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
            thousands = thousands || ',';
            decimal = decimal || '.';
            if (isNaN(number) || number === null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? decimal + parts[1] : '';
            return dollarsAmount + centsAmount;
        }
        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
        }
        return formatString.replace(placeholderRegex, value);
    }
    return {
        formatMoney: formatMoney
    };
})();
slate.Variants = (function() {
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();
        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }
    Variants.prototype = _.assignIn({}, Variants.prototype, {
        _getCurrentOptions: function() {
            var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};
                if (type === 'radio' || type === 'checkbox') {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');
                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');
                    return currentOption;
                }
            });
            currentOptions = _.compact(currentOptions);
            return currentOptions;
        },
        _getVariantFromOptions: function() {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = _.find(variants, function(variant) {
                return selectedValues.every(function(values) {
                    return _.isEqual(variant[values.index], values.value);
                });
            });
            return found;
        },
        _onSelectChange: function() {
            var variant = this._getVariantFromOptions();
            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });
            if (!variant) {
                return;
            }
            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this._updateSKU(variant);
            this.currentVariant = variant;
            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },
        _updateImages: function(variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};
            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }
            this.$container.trigger({
                type: 'variantImageChange',
                variant: variant
            });
        },
        _updatePrice: function(variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }
            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });
        },
        _updateSKU: function(variant) {
            if (variant.sku === this.currentVariant.sku) {
                return;
            }
            this.$container.trigger({
                type: 'variantSKUChange',
                variant: variant
            });
        },
        _updateHistoryState: function(variant) {
            if (!history.replaceState || !variant) {
                return;
            }
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({
                path: newurl
            }, '', newurl);
        },
        _updateMasterSelect: function(variant) {
            $(this.originalSelectorId, this.$container).val(variant.id);
        }
    });
    return Variants;
})();
window.theme = theme || {};
// RecoverPassword Page Login
theme.customerTemplates = (function() {
    function initEventListeners() {
        // Show reset password form
        $('#RecoverPassword').on('click', function(evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        });

        // Hide reset password form
        $('#HideRecoverPasswordLink').on('click', function(evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        });
    }

    /* Show/Hide recover password form */
    function toggleRecoverPasswordForm() {
        $('#RecoverPasswordForm').toggleClass('hide');
        $('#CustomerLoginForm').toggleClass('hide');
    }

    /* Show reset password success message */
    function resetPasswordSuccess() {
        var $formState = $('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!$formState.length) {
          return;
        }

        // show success message
        $('#ResetSuccess').removeClass('hide');
    }

    /* Show/hide customer address forms */
    function customerAddressForm() {
        var $newAddressForm = $('#AddressNewForm');

        if (!$newAddressForm.length) {
          return;
        }

        // Initialize observers on address selectors, defined in shopify_common.js
        if (Shopify) {
            // eslint-disable-next-line no-new
            new Shopify.CountryProvinceSelector(
                'AddressCountryNew',
                'AddressProvinceNew',
                {
                  hideElement: 'AddressProvinceContainerNew'
                }
            );
        }

        // Initialize each edit form's country/province selector
        $('.address-country-option').each(function() {
            var formId = $(this).data('form-id');
            var countrySelector = 'AddressCountry_' + formId;
            var provinceSelector = 'AddressProvince_' + formId;
            var containerSelector = 'AddressProvinceContainer_' + formId;

            // eslint-disable-next-line no-new
            new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
                hideElement: containerSelector
            });
        });

        // Toggle new/edit address forms
        $('.address-new-toggle').on('click', function() {
            $newAddressForm.toggleClass('hide');
        });

        $('.address-edit-toggle').on('click', function() {
            var formId = $(this).data('form-id');
            $('#EditAddress_' + formId).toggleClass('hide');
        });

        $('.address-delete').on('click', function() {
            var $el = $(this);
            var formId = $el.data('form-id');
            var confirmMessage = $el.data('confirm-message');

            // eslint-disable-next-line no-alert
            if (
                confirm(
                    confirmMessage || 'Are you sure you wish to delete this address?'
                )
            ) {
                Shopify.postLink('/account/addresses/' + formId, {
                    parameters: { _method: 'delete' }
                });
            }
        });
    }

    /* Check URL for reset password hash */
    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
          toggleRecoverPasswordForm();
        }
    }

    return {
        init: function() {
            checkUrlHash();
            initEventListeners();
            resetPasswordSuccess();
            customerAddressForm();
        }
    };
})();
// RecoverPassword Popup Index
theme.customerloginTemplates = (function() {
    function initEventsListeners() {
        // Show reset password form
        $('#RecoversPassword').on('click', function(evt) {
            evt.preventDefault();
            toggleRecoverPasswordFormIndex();
        });

        // Hide reset password form
        $('#HideRecoverPasswordIndex').on('click', function(evt) {
            evt.preventDefault();
            toggleRecoverPasswordFormIndex();
        });
    }

    /* Show/Hide recover password form */
    function toggleRecoverPasswordFormIndex() {
        $('#RecoverPasswordFormIndex').slideToggle('fast');
    }
    return {
        init: function() {
            initEventsListeners();
        }
    };
})();
window.theme = window.theme || {};
theme.Cart = (function() {
    var selectors = {
        edit: '.js-edit-toggle'
    };
    var config = {
        showClass: 'cart__update--show',
        showEditClass: 'cart__edit--active',
        cartNoCookies: 'cart--no-cookies'
    };

    function Cart(container) {
        this.$container = $(container);
        this.$edit = $(selectors.edit, this.$container);
        if (!this.cookiesEnabled()) {
            this.$container.addClass(config.cartNoCookies);
        }
        this.$edit.on('click', this._onEditClick.bind(this));
    }
    Cart.prototype = _.assignIn({}, Cart.prototype, {
        onUnload: function() {
            this.$edit.off('click', this._onEditClick);
        },
        _onEditClick: function(evt) {
            var $evtTarget = $(evt.target);
            var $updateLine = $('.' + $evtTarget.data('target'));
            $evtTarget.toggleClass(config.showEditClass);
            $updateLine.toggleClass(config.showClass);
        },
        cookiesEnabled: function() {
            var cookieEnabled = navigator.cookieEnabled;
            if (!cookieEnabled) {
                document.cookie = 'testcookie';
                cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
            }
            return cookieEnabled;
        }
    });
    return Cart;
})();
theme.Nov_Owlcarousel = (function() {
    function Nov_Owlcarousel(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        var slider = (this.slider = '#shopify-section-' + sectionId + ' .nov-owl-carousel');
        if ($('html').hasClass('lang-rtl'))
            var rtl = true;
        else
            var rtl = false;
        var autoplay = $(slider).data('autoplay'),
            autoplaytimeout = $(slider).data('autoplaytimeout'),
            margin = $(slider).data('margin'),
            nav = $(slider).data('nav'),
            dots = $(slider).data('dots'),
            loop = $(slider).data('loop'),
            items = $(slider).data('items'),
            items_tablet = $(slider).data('items_tablet'),
            items_mobile = $(slider).data('items_mobile'),
            center = $(slider).data('center'),
            start = $(slider).data('start'),
            autowidth = $(slider).data('autowidth');
        $(slider).owlCarousel({
            navText: ['<i class="zmdi zmdi-chevron-left"></i>', '<i class="zmdi zmdi-chevron-right"></i>'],
            lazyLoad: true,
            lazyContent: true,
            loop: loop,
            autoplay: autoplay,
            autoplayTimeout: autoplaytimeout,
            items: items,
            margin: margin,
            rtl: rtl,
            dots: dots,
            nav: nav,
            center: center,
            autoWidth: autowidth,
            responsive: {
                0: {
                    items: items_mobile,
                    loop: true,
                    autoHeight: true,
                    autoWidth: false
                },
                768: {
                    items: items_tablet,
                    autoWidth: false
                },
                1200: {
                    items: items,
                    center: center
                },
            }
        });
    }
    return Nov_Owlcarousel;
})();
theme.Nov_Slickcarousel = (function() {
    function Nov_Slickcarousel(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        var slider = (this.slider = '#shopify-section-' + sectionId + ' .nov-slick-carousel');
        var sliderNavfor = (this.slider = '#shopify-section-' + sectionId + ' .nov-slick-navfor-carousel');
        if ($('html').hasClass('lang-rtl')) {
            var rtl = true;
            var navrtl = true;
        } else {
            var rtl = false;
            var navrtl = false;
        }
        var autoplay = $(slider).data("autoplay"),
            autoplaytimeout = $(slider).data("autoplaytimeout"),
            infinite = $(slider).data("loop"),
            dots = $(slider).data("dots"),
            nav = $(slider).data("nav"),
            rows = $(slider).data("row"),
            row_mobile = $(slider).data("row_mobile") ? $(slider).data("row_mobile") : 1,
            fade = $(slider).data("fade"),
            items = $(slider).data("items"),
            items_xxl = $(slider).data("items_xxl") ? $(slider).data("items_xxl") : items,
            items_lg = $(slider).data("items_lg"),
            items_md = $(slider).data("items_md"),
            items_sm = $(slider).data("items_sm"),
            items_xs = $(slider).data("items_xs") ? $(slider).data("items_xs") : 1,
            unslick_xs = $(slider).data("unslick"),
            custnav = $(slider).data("custnav"),
            navfor = $(slider).data("navfor"),
            oneslider = $(slider).data("oneslider"),
            vertical = $(slider).data("vertical"),
            swipe = $(slider).data("swipe"),
            speed = $(slider).data("speed"),
            focus = $(slider).data("focus"),
            adaptiveheight = $(slider).data("adaptiveheight"),
            variablewidth = $(slider).data("variablewidth"),
            hover = $(slider).data("hover"),
            center = $(slider).data("center");
        if (typeof navfor!= "undefined" && navfor == true ) {
            syncing = sliderNavfor;
        } else {
            syncing = null;
        }

        if (typeof custnav!= "undefined" && $(window).width() > 1199) {
          nav = false;
        }
        if (vertical == true) {
            rtl = false
        }
        if ($(slider).hasClass('video-play')) {
            $(slider).on("init", function(slick) {
                $(slider).find('.slick-current video').trigger('play');
            });
        }
        
        $(slider).slick({
            nextArrow: '<div class="arrow-next"><i class="rbb-icon-direction-39"></i></div>',
            prevArrow: '<div class="arrow-prev"><i class="rbb-icon-direction-36"></i></div>',
            rtl: rtl,
            slidesToShow: items_xxl,
            slidesToScroll: $(slider).data("oneslider") ? $(slider).data("oneslider") : items_xxl,
            rows: rows,
            arrows: nav,
            dots: dots,
            infinite: infinite,
            fade: fade,
            speed: speed,
            autoplay: autoplay,
            autoplaySpeed: autoplaytimeout,
            vertical: vertical,
            asNavFor: syncing,
            pauseOnFocus: focus,
            pauseOnHover: hover,
            swipe: swipe,
            adaptiveHeight: adaptiveheight,
            variableWidth: variablewidth,
            centerMode: center,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: items,
                        slidesToScroll: $(slider).data("oneslider") ? 1 : items
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: items_lg,
                        slidesToScroll: $(slider).data("oneslider") ? 1 : items_lg
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: items_md,
                        slidesToScroll: $(slider).data("oneslider") ? 1 : items_md
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: items_sm,
                        slidesToScroll: $(slider).data("oneslider") ? 1 : items_sm,
                        rows: row_mobile
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: items_xs,
                        slidesToScroll: $(slider).data("oneslider") ? 1 : items_xs,
                        rows: row_mobile
                    }
                }
            ]
        });

        var navautoplay = $(sliderNavfor).data("autoplay"),
            navautoplaytimeout = $(sliderNavfor).data("autoplaytimeout"),
            navinfinite = $(sliderNavfor).data("loop"),
            navdots = $(sliderNavfor).data("dots"),
            navnav = $(sliderNavfor).data("nav"),
            navfade = $(sliderNavfor).data("fade"),
            center = $(sliderNavfor).data("center"),
            variablewidth = $(sliderNavfor).data("variablewidth"),
            navitems_xl = $(sliderNavfor).data("items_xl"),
            navitems_lg = $(sliderNavfor).data("items_lg"),
            navitems_md = $(sliderNavfor).data("items_md"),
            navitems_sm = $(sliderNavfor).data("items_sm"),
            navitems_xs = $(sliderNavfor).data("items_xs") ? $(sliderNavfor).data("items_xs") : 1,
            navfor = $(sliderNavfor).data("navfor"),
            navspeed = $(sliderNavfor).data("speed"),
            navfocus = $(sliderNavfor).data("focus"),
            navswipe = $(sliderNavfor).data("swipe"),
            navhover = $(sliderNavfor).data("hover");
            if (typeof navfor!= "undefined" && navfor == true ) {
                syncing = slider;
            } else {
                syncing = null;
            }
        $(sliderNavfor).slick({
            nextArrow: '<div class="arrow-next"><i class="rbb-icon-direction-39"></i></div>',
            prevArrow: '<div class="arrow-prev"><i class="rbb-icon-direction-36"></i></div>',
            rtl: navrtl,
            slidesToShow: navitems_xl,
            slidesToScroll: navitems_xl,
            dots: navdots,
            arrows: navnav,
            infinite: navinfinite,
            fade: navfade,
            autoplay: navautoplay,
            autoplaySpeed: navautoplaytimeout,
            asNavFor: syncing,
            centerMode: center,
            variableWidth: variablewidth,
            speed: navspeed,
            pauseOnFocus: navfocus,
            pauseOnHover: navhover,
            swipe: navswipe,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: navitems_xl,
                        slidesToScroll: navitems_xl
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: navitems_lg,
                        slidesToScroll: navitems_lg
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: navitems_md,
                        slidesToScroll: navitems_md
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: navitems_sm,
                        slidesToScroll: navitems_sm
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: navitems_xs,
                        slidesToScroll: navitems_xs
                    }
                }
            ]
        });

        checkClasses(slider);
        var currentSlide = $(slider).slick('slickCurrentSlide');
        if ($(slider).find('.slick-cloned').length == 0) {
            checkArrow(slider, currentSlide);
        }
        $(slider).on('afterChange', function(event, slick, currentSlide, nextSlide){
            checkClasses(slider);
            if (infinite == false) {
                checkArrow(slider, currentSlide);
            }
            if ($('#shopify-section-' + sectionId).find('[data-slick-to]').length > 0) {
                var index = $(slider).slick('slickCurrentSlide');
                $('[data-slick-to]').removeAttr('current');
                $('[data-slick-to][data-index='+ index +']').attr('current', '');
            }
            if ($(slider).hasClass('video-play')) {
                $(slider).find('video').trigger('pause');
                $(slider).find('.slick-current video').trigger('play');
            }
        });
        function checkClasses(class_parent) {
            if ($('html').hasClass('lang-rtl'))
                rtl = true;
            else
                rtl = false;
            var total = $('.slick-list .slick-active', class_parent).length;
            $('.slick-list .slick-slide', class_parent).removeClass('firstActiveItem lastActiveItem');

            $('.slick-list .slick-active', class_parent).each(function (index) {
                if (index === 0 && rtl === false) {
                    // this is the first one
                    $(this).addClass('firstActiveItem');
                } else if (index === 0 && rtl === true) {
                    $(this).addClass('lastActiveItem');
                }
                if (index === total - 1 && total > 1 && rtl === false) {
                    // this is the last one
                    $(this).addClass('lastActiveItem');
                } else if (index === total - 1 && total > 1 && rtl === true) {
                    $(this).addClass('firstActiveItem');
                }
            });
        }
        function checkArrow(el, current) {
            var num = $(el).find('.slick-slide').length,
                num_act = $(el).find('.slick-active').length,
                prev = $(el).parents('[data-section-type="nov-slick"]').find('.nav-slider--prev'),
                next = $(el).parents('[data-section-type="nov-slick"]').find('.nav-slider--next');
            if (num - num_act == 0) {
                prev.css('visibility', 'hidden');
                next.css('visibility', 'hidden');
            } else {
                prev.css('visibility', 'visible');
                next.css('visibility', 'visible');
            }
            if(current == 0) {
                prev.addClass('disabled');
            } else {
                prev.removeClass('disabled');
            }
            if (num - num_act <= current) {
                next.addClass('disabled');
            } else {
                next.removeClass('disabled');
            }
        };
        if (typeof custnav != "undefined") {
            $('.nav-slider--prev', '#shopify-section-' + sectionId).click(function(){
               $(slider).slick('slickPrev');
            });
            $('.nav-slider--next', '#shopify-section-' + sectionId).click(function(){
               $(slider).slick('slickNext');
            })
        }
        $('[data-slick-to]', '#shopify-section-' + sectionId).on('click', function(event) {
            event.preventDefault();
            $('[data-slick-to]', '#shopify-section-' + sectionId).removeAttr('current');
            $(this).attr('current', '');
            var goToSingleSlide = $(this).data('index');
            $(slider).slick('slickGoTo', goToSingleSlide);
        });
        if ($(window).width() < 576 && unslick_xs == true ) {
            $(slider).slick('unslick');
        }
    }
    return Nov_Slickcarousel;
})();
theme.Nov_SliderShow = (function() {
    function Nov_SliderShow(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        var slideWrapper = (this.slideWrapper = '#shopify-section-' + sectionId + ' .main-slider');
        
        if($('html').hasClass('lang-rtl'))
            var rtl = true;
        else
            var rtl = false;

        var autoplay = $(slideWrapper).data('autoplay'),
            speed = $(slideWrapper).data('speed'),
            arrows = $(slideWrapper).data('arrows'),
            dots = $(slideWrapper).data('dots'),
            iframes = $(slideWrapper).find('.embed-player'),
            lazyImages = $(slideWrapper).find('.slide-image'),
            loadingBar = $(slideWrapper).data('loading-bar');
            zoom = $(slideWrapper).data('zoom');
        $(function() {
            $(".caption-animate", '.slick-current').each(function() {
                var caption = $(this).data("animate");
                $(this).removeClass(caption);
            });
            $(slideWrapper).on("init", function(slick) {
                slick = $(slick.currentTarget);
                if (autoplay == true && typeof loadingBar != "undefined") {
                    $(slideWrapper).find('.slick-current').addClass('timer');
                }
                $('[data-slick-to][data-index="0"]', '#shopify-section-' + sectionId).attr('current','');
                $(slideWrapper).find('.slick-current video').trigger('play');
                setTimeout(function() {
                    $(slideWrapper).find(".slick-current .slide-image").addClass("first-zoomin");
                    $(".caption-animate", '.slick-current').each(function() {
                        var caption = $(this).data("animate");
                        $(this).addClass(caption);
                    });
                }, 500);
            });
           $(slideWrapper).on("beforeChange", function(event, slick) {
                slick = $(slick.$slider);
                $(".caption-animate", '.slick-current').each(function() {
                    var caption = $(this).data("animate");
                    $(this).removeClass(caption);
                });
                if (zoom == true) {
                    $(slideWrapper).find(".slick-current .slide-image").removeClass("zoom_img");
                }
                if (autoplay == true && typeof loadingBar != "undefined") {
                    $(slideWrapper).find('.slick-current').removeClass('timer');
                }
                $(slideWrapper).find(".slide-image").removeClass('first-zoomin');
                $(slideWrapper).find(".slide-image").removeClass('first-scale');
            });
           $(slideWrapper).on("afterChange", function(event, slick, currentSlide) {
                $(".caption-animate", '.slick-current').each(function() {
                    var caption = $(this).data("animate");
                    $(this).addClass(caption);
                });
                if (zoom == true) {
                    $(slideWrapper).find(".slick-current .slide-image").addClass("zoom_img");
                }
                if (autoplay == true && typeof loadingBar != "undefined") {
                    $(slideWrapper).find('.slick-current').addClass('timer');
                }
                $(slideWrapper).find('video').trigger('pause');
                $(slideWrapper).find('.slick-current video').trigger('play');
                $('[data-slick-to]', '#shopify-section-' + sectionId).removeAttr('current');
                $('[data-slick-to][data-index="'+ currentSlide +'"]', '#shopify-section-' + sectionId).attr('current', '');

                slick = $(slick.$slider);
            });

            $(slideWrapper).slick({
                fade: true,
                nextArrow: '<div class="arrow-next"><i class="rbb-icon-direction-39"></i></div>',
                prevArrow: '<div class="arrow-prev"><i class="rbb-icon-direction-36"></i></div>',
                autoplay: autoplay,
                autoplaySpeed: speed,
                lazyLoad: "progressive",
                pauseOnHover: false,
                pauseOnFocus: false,
                speed: 600,
                arrows: arrows,
                dots: dots,
                cssEase: "cubic-bezier(0.87, 0.03, 0.41, 0.9)",
                rtl: rtl,
                adaptiveHeight: true,
            });
            $('[data-slick-to]', '#shopify-section-' + sectionId).on('click', function(event) {
                event.preventDefault();
                $('[data-slick-to]', '#shopify-section-' + sectionId).removeAttr('current');
                $(this).attr('current', '');
                var goToSingleSlide = $(this).data('index');
                $(slideWrapper).slick('slickGoTo', goToSingleSlide);
            });
        });
    }
    return Nov_SliderShow;
})();
$(document).ready(function() {
    var sections = new theme.Sections();
    sections.register('cart-template', theme.Cart);
    sections.register('slideshow-section', theme.Nov_SliderShow);
    sections.register('nov-owl', theme.Nov_Owlcarousel);
    sections.register('nov-slick', theme.Nov_Slickcarousel);
});
theme.init = function() {
    theme.customerTemplates.init();
    theme.customerloginTemplates.init();
    var tableSelectors = '.rte table,' + '.custom__item-inner--html table';
    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'scrollable-wrapper'
    });
    slate.a11y.pageLinkFocus($(window.location.hash));
    $('.in-page-link').on('click', function(evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });
    $('a[href="#"]').on('click', function(evt) {
        evt.preventDefault();
    });
};
$(theme.init);

document.addEventListener("DOMContentLoaded", function () {
  // Select the span element inside the label
  var newsletterText = document.querySelector('label[for="register__newsletter"] .text');
  
  // Check if the element exists before changing the text
  if (newsletterText) {
    newsletterText.textContent = "Sign up to get upcoming offers";
  }
});

